/* eslint-disable no-bitwise */
import { AddressMeta } from "../../form/address-finder-input";

export enum CustomerFormQuestionTypes {
  None = 0,
  DatePicker = 1 << 0, // 0001 -- the bitshift is unnecessary, but done for consistency
  AddressFinder = 1 << 1, // 0010
  BankAccount = 1 << 2, // 0100
  FileUpload = 1 << 3, // 0101
}

interface HTMLElement {
  type: "html";
  html: string;
}

interface TextElement {
  type: "text";
  name: string;
  title: string;
  isRequired?: boolean;
  startWithNewLine?: boolean;
  placeHolder?: string;
  defaultValue?: string;
  readOnly?: boolean;
  validators?: { type: string }[];
  visibleIf?: string;
}

type Element = HTMLElement | TextElement;

interface BaseQuestion {
  name: string;
  title: string;
  isRequired?: boolean;
  startWithNewLine?: boolean;
  visibleIf?: string;
  validators?: {
    type: "expression" | "email" | "numeric";
    expression?: string;
    text?: string;
  }[];
  readOnly?: boolean;
}

interface ExpressionQuestion extends BaseQuestion {
  type: "expression";
  expression: string;
  displayStyle?: string;
  currency?: string;
}

interface TextQuestion extends BaseQuestion {
  type: "text" | "comment";
  placeHolder?: string;
  defaultValue?: string;
}

interface DateQuestion extends BaseQuestion {
  type: "datepicker";
  inputType: "date";
}

interface FileQuestion extends BaseQuestion {
  type: "file";
  storeDataAsText?: boolean;
  allowMultiple?: boolean;
  maxSize?: number;
  waitForUpload?: boolean;
}

interface AddressQuestion extends BaseQuestion {
  type: "addressfinder";
  defaultValue?: AddressMeta;
}

export interface RadioGroupChoice {
  text: string;
  value: string | number;
}

interface RadioGroupQuestion extends BaseQuestion {
  type: "radiogroup";
  choices: string[] | RadioGroupChoice[];
}

interface SignatureQuestion extends BaseQuestion {
  type: "signaturepad";
  penColor: string;
  width: number;
}

interface BankAccountQuestion extends BaseQuestion {
  type: "bankaccount";
}

interface MatrixDynamicQuestion extends BaseQuestion {
  type: "matrixdynamic";
  description: string;
  addRowText: string;
  columnMinWidth: string;
  cellType?: string;
  choices?: RadioGroupChoice[];
  columns: {
    name: string;
    title: String;
    cellType?: string;
    isRequired?: boolean;
    minWidth?: string;
    choices?: string[] | number[];
    totalType?: string;
    totalFormat?: string;
    inputType?: string;
    totalAlignment?: string;
  }[];
  rowCount: number;
  minRowCount: number;
  maxRowCount: number;
}

export type Question =
  | AddressQuestion
  | BankAccountQuestion
  | DateQuestion
  | ExpressionQuestion
  | FileQuestion
  | MatrixDynamicQuestion
  | RadioGroupQuestion
  | SignatureQuestion
  | TextQuestion;

export interface PageConfig {
  name: string;
  title?: string;
  description?: string;
  visibleIf?: string;
  elements?: Element[];
  questions?: Question[];
}

export interface SurveyConfig {
  pages: PageConfig[];
  completedHtml?: string;
}
